// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue          from 'vue'
import App          from './app/app'
import { store }    from './store'
import router       from './router'
import i18n         from './locales/i18n'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import 'fullcalendar/dist/fullcalendar.min.css'

Vue.config.productionTip = false

new Vue({
	el: '#app',
	template: '<App/>',
	store,
	components: { App },
	router,
	i18n
})



// WEBPACK FOOTER //
// ./src/main.js